<template>
    <div class="gap-4 md:items-center grid grid-cols-12">
        <div class="col-span-full md:col-span-6" :class="{'md:col-start-2 lg:!col-start-3': isEven}">
            <ResponsiveImage
                v-if="image"
                :image-id="image"
                class="w-full rounded-sm"
                loading="lazy"
            />
        </div>
        <div class="flex flex-col gap-6 col-span-full md:col-span-5 lg:col-span-3">
            <div class="view-h4 uppercase">{{title}}</div>
            <RenderedHTML :value="body" />
<!--            <div v-html="body_value"></div>-->

        </div>
    </div>
</template>

<script lang="ts" setup>

import type { JSONContent } from "@tiptap/vue-3"
import RenderedHTML from "~/components/view/RenderedHTML.vue"

const { image, body, title, isEven } = defineProps({
    image: String,
    body: Object as PropType<JSONContent>,
    title: String,
    isEven: Boolean
})

</script>
